import React, { useState, useRef } from 'react';
import Login from './components/Login';
import Modes from './components/Modes';

export default function App(){
  const [token, setToken] = useState(localStorage.getItem('jwt')||'');
  const onLogin = (t)=>{ setToken(t); localStorage.setItem('jwt', t); }
  return (
    <div style={{maxWidth:900,margin:'20px auto',fontFamily:'Arial'}}>
      <h1>SSSLS Web Interface</h1>
      {!token ? <Login onLogin={onLogin}/> : <Modes token={token} onLogout={()=>{localStorage.removeItem('jwt'); setToken('')}} />}
    </div>
  );
}

